import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const BingoRegister = lazyRouteComponent(() => import('../pages/bingo-register'))

export const bingoRegisterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/bingo-register',
  component: BingoRegister,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
